export const PathsEnum = {
    Dashboard: {
      Main: 'dashboard',
    },
    Reports: {
      Programmed: 'dashboard/reports/programmed',
      Programation: 'dashboard/reports/programation',
      ProgressQuestionnaire: 'dashboard/reports/progress-questionnaire',
    },
    OrganizationChart: {
      Area: 'dashboard/organization-chart/area',
      Departments: 'dashboard/organization-chart/departments',
      AreaDepartment: 'dashboard/organization-chart/organization-area-department',
    },
    Service: {
      TimeConfig: 'dashboard/report-folio/time-config',
    },
    User: {
      Register: 'dashboard/user/register',
      UserType: 'dashboard/user/user-type',
    },
    Unit: {
      Store: 'dashboard/unit/store',
      Division: 'dashboard/unit/division',
      Zone: 'dashboard/unit/zone',
    },
    Questionnaire: {
      Main: 'dashboard/questionnarie/main',
    },
    Calendar: {
      Main: 'dashboard/calendar',
    },
    ScheduleUser: {
      Main: 'dashboard/schedule-user/',
    },
    ActionPlan: {
      Created: 'dashboard/action-plan/created',
      ToGenerate: 'dashboard/action-plan/to-generate',
    },
    ReportFolio: {
      Dashboard: 'dashboard/report-folio/dashboard',
      Settings: 'dashboard/report-folio/settings',
    },
    Setting: {
      AdminUsers: 'dashboard/setting/admin-users',
      OptionGroup: 'dashboard/setting/option-group',
      Companies: 'dashboard/setting/companies',
    },
    Localization: {
      Main: 'dashboard/localization/main',
    },
  };
  